import { render, staticRenderFns } from "./UnFinished.vue?vue&type=template&id=1c924652&scoped=true"
import script from "./UnFinished.vue?vue&type=script&lang=js"
export * from "./UnFinished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c924652",
  null
  
)

export default component.exports